var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-item"},[_c('p',[_vm._v(_vm._s(_vm.filterItem.text))]),_c('button',{on:{"click":_vm.removeFilterItem}},[_c('Icon',{attrs:{"icon":"x"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }